// ----- Terms & Conditions ----- //
const privacyLink = 'https://www.theguardian.com/help/privacy-policy';
const guardianHelpCentreLink = 'https://www.theguardian.com/help';
const guardianContactUsLink = 'https://www.theguardian.com/help/contact-us';
const defaultContributionEmail = 'mailto:contribution.support@theguardian.com';
const copyrightNotice = `\u00A9 ${new Date().getFullYear()} Guardian News and Media Limited or its
  affiliated companies. All rights reserved.`;
const contributionsEmail = {
    AUDCountries: 'mailto:apac.help@theguardian.com',
    GBPCountries: defaultContributionEmail,
    UnitedStates: defaultContributionEmail,
    EURCountries: defaultContributionEmail,
    International: defaultContributionEmail,
    NZDCountries: defaultContributionEmail,
    Canada: defaultContributionEmail,
};
const defaultContributionTermsLink = 'https://www.theguardian.com/info/2016/apr/04/contribution-terms-and-conditions';
const contributionsTermsLinks = {
    GBPCountries: defaultContributionTermsLink,
    UnitedStates: 'https://www.theguardian.com/info/2016/apr/07/us-contribution-terms-and-conditions',
    AUDCountries: 'https://www.theguardian.com/info/2016/apr/08/australia-contribution-terms-and-conditions',
    EURCountries: defaultContributionTermsLink,
    International: defaultContributionTermsLink,
    NZDCountries: defaultContributionTermsLink,
    Canada: defaultContributionTermsLink,
};
const guardianLiveTermsLink = 'https://www.theguardian.com/info/2014/sep/09/guardian-live-events-terms-and-conditions';
const supporterPlusTermsLink = 'https://www.theguardian.com/info/2025/oct/31/guardian-subscription-terms-and-conditions';
const guardianAdLiteTermsLink = `https://www.theguardian.com/guardian-ad-lite-tcs`;
const paperTermsLink = 'https://www.theguardian.com/info/2021/aug/04/guardian-and-observer-voucher-subscription-card-and-home-delivery-subscription-services-terms-and-conditions';
const digitalPlusTermsLink = 'https://www.theguardian.com/info/2025/oct/31/guardian-subscription-terms-and-conditions';
const guardianWeeklyTermsLink = 'https://www.theguardian.com/info/2026/mar/10/guardian-weekly-subscription-terms-and-conditions';
const manageAccountLink = 'https://manage.theguardian.com';
const observerLinks = {
    TERMS: 'https://observer.co.uk/policy/terms',
    PRIVACY: 'https://observer.co.uk/policy/privacy',
};
var MediaGroup;
(function (MediaGroup) {
    MediaGroup["GUARDIAN"] = "Guardian News & Media Ltd";
    MediaGroup["TORTOISE"] = "GC re Tortoise Media Ltd t/a The Observer";
})(MediaGroup || (MediaGroup = {}));
export { guardianContactUsLink, guardianHelpCentreLink, defaultContributionEmail, contributionsTermsLinks, privacyLink, copyrightNotice, contributionsEmail, guardianLiveTermsLink, supporterPlusTermsLink, guardianAdLiteTermsLink, paperTermsLink, digitalPlusTermsLink, guardianWeeklyTermsLink, observerLinks, manageAccountLink, MediaGroup, };
